












































































































import useAssignChat from "@/composables/v3/useAssignChat";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { useTeamsStore } from "@/store/useTeamsStore";
import { useUsersStore } from "@/store/useUsersStore";
import { Team } from "@/types/team.types";
import { User } from "@/types/user.types";
import { resolveTeamsUsersTree, resolveUserStatus } from "@/utils/users";
import { computed, defineComponent, ref } from "@vue/composition-api";
import { useFocus } from "@vueuse/core";
import {
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItemButton,
    BFormInput,
    VBTooltip,
} from "bootstrap-vue";

export default defineComponent({
    components: {
        BDropdown,
        BDropdownDivider,
        BDropdownForm,
        BDropdownGroup,
        BDropdownItemButton,
        BFormInput,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const usersStore = useUsersStore();
        const teamsStore = useTeamsStore();
        const chatsStore = useChatsStore();
        const channelsStore = useChannelsStore();

        const { isAssignPending, assign, unassign, assignToMe } = useAssignChat();

        const assignedUser = computed((): User => {
            if (chatsStore.activeChat?.chat.assignedUserId) {
                return usersStore.getUserById(chatsStore.activeChat.chat.assignedUserId);
            }
        });

        const assignedTeam = computed((): Team => {
            if (chatsStore.activeChat?.chat.assignedTeamId) {
                return teamsStore.getTeamById(chatsStore.activeChat.chat.assignedTeamId);
            }
        });

        const assignee = computed((): User | Team => assignedUser.value ?? assignedTeam.value);

        const searchQueryRef = ref(null);
        const searchQueryValue = ref("");

        const usersTeamsTree = computed(() =>
            resolveTeamsUsersTree(teamsStore.teams, usersStore.users, searchQueryValue, channelsStore.activeChatChannel)
        );

        return {
            assign,
            assignToMe,
            assignedTeam,
            assignedUser,
            assignee,
            chatsStore,
            isAssignPending,
            resolveUserStatus,
            searchQueryRef,
            searchQueryValue,
            unassign,
            useFocus,
            usersTeamsTree,
        };
    },
});
